import Button from 'components/button/Button';
import Link from 'components/link/Link';

import { ITabMenu } from 'source/NFR.types';

interface ITabMenuProps extends ITabMenu {
  openMenu?: () => void;
}

const TabMenu: React.FC<ITabMenuProps> = ({ mainContentLink, filtersLink, openMenu, openMenuLabel }) => (
  <nav className="tab-menu">
    <ul>
      <li>
        <Link theme="white" {...mainContentLink} />
      </li>
      <li>
        <Button onClick={openMenu}>{openMenuLabel}</Button>
      </li>
      <li>
        <Link theme="white" {...filtersLink} />
      </li>
    </ul>
  </nav>
);

TabMenu.displayName = 'TabMenu';

export default TabMenu;
